module.exports = __webpack_public_path__ + "static/img/trainCultivate-icon.721a2127.png";